import { applyTokens } from "../../../utilities/applyTokens.js";
import { createFocusStyle } from "../utils/createFocusStyle.js";
const input = (tokens) => {
    var _a;
    const { component: { button: { small, iconOnly }, input: { medium, outlined }, }, semantic: { iconSize }, } = tokens;
    // find the same token in `iconSizes`
    const iconSizeKey = (_a = Object.entries(iconSize).find(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_, value]) => value.value === medium.icon.width.value)) === null || _a === void 0 ? void 0 : _a[0];
    return {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    "&&": Object.assign(Object.assign(Object.assign({ boxSizing: "border-box" }, applyTokens(medium.container)), applyTokens(medium.input)), { "&::placeholder": {
                            opacity: 1,
                            color: outlined.default.placeholder.color.value,
                        } }),
                },
                adornedStart: {
                    "&&": {
                        paddingLeft: medium.container.paddingLeft.value,
                    },
                },
                adornedEnd: {
                    "&&": {
                        paddingRight: medium.container.paddingRight.value,
                    },
                },
                inputAdornedStart: {
                    "&&": {
                        paddingLeft: 0,
                    },
                },
                inputAdornedEnd: {
                    "&&": {
                        paddingRight: 0,
                    },
                },
                multiline: {
                    "&&": {
                        padding: 0,
                        overflow: "hidden",
                    },
                },
                inputMultiline: {
                    "&&": Object.assign(Object.assign(Object.assign({}, applyTokens(medium.container)), applyTokens(medium.input)), { borderRadius: medium.border.borderRadius.value, lineHeight: medium.input.lineHeight.value, padding: `${medium.container.paddingTop.value} ${medium.container.paddingRight.value} ${medium.container.paddingBottom.value} ${medium.container.paddingLeft.value}` }),
                },
            },
        },
        MuiInput: {
            defaultProps: {
                disableUnderline: true,
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                notched: false,
            },
            styleOverrides: {
                root: {
                    borderRadius: medium.border.borderRadius.value,
                    "&:not(.Mui-disabled, .Mui-readOnly)": {
                        "&:hover": applyTokens(outlined.hover.container),
                        "&.Mui-focused": Object.assign(Object.assign(Object.assign({}, applyTokens(outlined.active.container)), createFocusStyle(tokens)), { ".MuiOutlinedInput-notchedOutline": applyTokens(outlined.active.border) }),
                    },
                    "&.Mui-disabled": Object.assign(Object.assign({}, applyTokens(outlined.disabled.container)), { " .MuiOutlinedInput-notchedOutline": applyTokens(outlined.disabled.border) }),
                    "&.Mui-readOnly": Object.assign(Object.assign({}, applyTokens(outlined.readOnly.container)), { " .MuiOutlinedInput-notchedOutline": applyTokens(outlined.readOnly.border), "& .MuiIconButton-root.Mui-disabled": {
                            backgroundColor: "transparent",
                        } }),
                    "&.Mui-error .MuiOutlinedInput-notchedOutline": applyTokens(outlined.error.border),
                },
                input: Object.assign(Object.assign({}, applyTokens(outlined.default.container)), { "&.Mui-readOnly": {
                        background: "transparent",
                    } }),
                notchedOutline: Object.assign(Object.assign(Object.assign({}, applyTokens(medium.border)), applyTokens(outlined.default.border)), { "&:hover": applyTokens(outlined.hover.border), "& > legend": {
                        width: 0,
                    } }),
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: Object.assign({ gap: medium.container.gap.value, color: outlined.default.adornment.color.value, "& .notranslate": {
                        marginRight: `-${medium.container.gap.value}`,
                    }, 
                    // We need to enforce the size for icon buttons placed inside the input
                    "& .MuiIconButton-root": Object.assign(Object.assign(Object.assign({}, applyTokens(small)), applyTokens(iconOnly.small)), { marginRight: 0 }) }, (iconSizeKey && {
                    "--atlas-icon-size": iconSizeKey,
                })),
                positionStart: {
                    marginRight: medium.container.gap.value,
                },
                positionEnd: {
                    marginLeft: medium.container.gap.value,
                },
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
        },
    };
};
export default input;
//# sourceMappingURL=input.js.map